module.exports = {

    panels: {
        textures: [
            'res/common/progressive_jackpot/jp_panel.png',
            'res/common/progressive_jackpot/jp_panel.png',
            'res/common/progressive_jackpot/jp_panel.png',
            'res/common/progressive_jackpot/jp_panel_galaxy.png',
        ],
        anchor: {x: 426/834, y: 266/378},
        position: {x: 512, y: 207+266}
    },

    jackpot_label: {
        position: {x: 783 - 426, y: 190 - 266},
        anchor: {x: 1, y: 0}
    },

    blick: {
        texture: 'res/common/progressive_jackpot/jp_blick.png',
        position: {x: 112 - 426, y: 62 - 266}
    },

    splash: {
        texture: 'res/common/progressive_jackpot/jp_blick.png',
        anchor: {x: 0.5, y: 0.5},
        position: {x: 0, y: -140}
    },

    pressStart: {
        texture: 'res/common/progressive_jackpot/jp_press_start.png',
        anchor: {x: 0.5, y: 0.5},
        position: {x: 512, y: 610}
    },


    creditsFrame: {
        texture: 'res/common/progressive_jackpot/jp_credits_panel.png',
        position: {x: 0, y: 768-52},
        text_position: {x:350, y:11},
        text_anchor: {x: 1, y:0}
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/library/cfg/progressive_jackpot_config.js
// module id = 115
// module chunks = 0